import React from 'react';
import { Form, Radio, RadioGroup, Modal, Button, Schema } from 'rsuite';
import { Field } from '../../../../helpers/rsuite/Form';
import { addStorage, asyncService, validator } from '../../../../helpers';
import { cuotitasStoreService } from '../../../../services';
import { alert } from '../../../../helpers/rsuite/Alerts';
import { errorMapper, getDataError } from '../../../../helpers/ErrorMappers';
import ENABLE from '../../../../constants/enable';
import { STEPS } from '../../../../constants/loanevents/steps';
import { logCustomEvent } from '../../../../../config/rum';
import { EVENTS } from '../../../../constants/rumevents/events';

const body0 = {
    width: '540px',
    padding: '0 4px',
};

const required = 'Este campo es requerido.';
const msgNumber = 'Por favor, ingrese un número valido.';
const { NumberType, StringType } = Schema.Types;
const modelCheckUser = Schema.Model({
    gender: StringType().isRequired(required),
    document: NumberType(msgNumber)
        .addRule((value, data) => {
            if (!validator.isDNI(String(value))) {
                return false;
            }

            return true;
        }, 'Por favor, ingrese un DNI valido (8 dígitos)')
        .isRequired(required),
});

export function checkPersonStep (context) {
    async function findUser () {
        try {
            context.setIsLoading(true);
            addStorage('headerExtra', { document: context?.formCheckUser?.document });

            const persons = ENABLE.enableGetPersonBank ? await cuotitasStoreService.getPersonByDocument(context?.formCheckUser?.document) : false;

            const options = {
                document: context?.formCheckUser?.document,
                gender: context?.formCheckUser?.gender
            };

            if (persons && persons.length > 0) {
                options.document = persons[0].documento;
                options.gender = persons[0].sexo;
                context.formCheckUser.gender = options.gender;
            }

            if (persons && persons.length > 1) {
                context.setRepeatUsers(persons);
                context.setStep(100);
            }
            else {
                const res = await asyncService((qss) => cuotitasStoreService.getPerson(options, qss));
                await context.populateUser(res.loanPerson);
                context.setFormMainUser(oldPerson => ({ ...oldPerson, bornDate: parseDate(persons[0].fechaNacimiento) }));
                context.setStep(99);
            }
        }
        catch (e) {
            // e = errorGetPersonBank;
            console.error(e);
            const dataError = getDataError(e); // TODO: Probar borrarlo y reutilizar msg
            const msg = errorMapper(e);

            // para mock
            if (ENABLE.enablePersonBankMock && dataError.extra.mensaje === 'No se encontró la persona en la base de datos.') {
                context.setStep(99);
            }

            else {
                // Si la persona no existe, debemos crearla en loan
                if (
                dataError?.error?.includes('Not found person with document') ||
                dataError?.error === 'No se encontró la persona en la base de datos.'
                ) {
                    try {
                        const persons = await cuotitasStoreService.getPersonByDocument(context?.formCheckUser?.document);
                        if (!persons[0]?.nombre || !persons[0]?.apellido) {
                            const fullName = `${persons[0]?.nombre} ${persons[0]?.apellido}`;

                            context.formCheckUser.document = persons[0]?.documento;
                            context.formCheckUser.gender = persons[0]?.sexo;

                            context.setFormFullNameUser(fullName.trim());

                            context.setFormMainUser(oldPerson => ({
                                ...oldPerson,
                                bornDate: parseDate(persons[0].fechaNacimiento) || oldPerson?.bornDate,
                                document: persons[0]?.documento,
                                gender: persons[0]?.sexo,
                            }));
                        }
                        else {
                            const response = await asyncService((qss) => cuotitasStoreService.createOrModifyUser({
                                firstName: persons[0]?.nombre,
                                lastName: persons[0]?.apellido,
                                document: persons[0]?.documento,
                                gender: persons[0]?.sexo,
                                bornDate: parseDate(persons[0]?.fechaNacimiento),
                                step: STEPS.PERSON_CREATION
                            }, qss));
                            await context.populateUser(response.loanPerson);
                        }
                        context.setStep(99);
                    }
                    catch (error) {
                        e.msg = msg;
                        const submitToast = () => context.submitToast(e);
                        alert(msg?.type, msg?.message, 0, 'topCenter', submitToast);
                    }
                }
                else {
                    e.msg = msg;
                    const submitToast = () => context.submitToast(e);
                    alert(msg?.type, msg?.message, 0, 'topCenter', submitToast);
                }
            }
        }
        finally {
            context.setIsLoading(false);
        }
    };

    async function submit () {
        if (ENABLE.enableGetPersonBank) {
            if (!context.formRef.current.checkForField('document')) {
                console.error('Form Error');
                return false;
            }
        }
        else {
            if (!context.formRef.current.check()) {
                console.error('Form Error');
                return false;
            }
        }
        if (context.formCheckUser) {
            logCustomEvent(EVENTS.CHECK_PERSON_STEP, {
                document: context.formCheckUser?.document,
                gender: context.formCheckUser?.gender,
            });
        }
        await findUser();
    };

    function parseDate (value) {
        const date = value?.split('/');
        if (value && date?.length === 3) {
            return new Date(`${date[1]}/${date[0]}/${date[2]}`);
        }
        return undefined;
    };

    return (
        <>
            <Modal.Body className='mb-5 h-100 py-1' style={{ height: '540px', overflow: 'show' }}>
                <div className='row m-0' style={body0}>
                    <Form
                        fluid
                        ref={context.formRef}
                        formValue={context.formCheckUser}
                        onChange={context.setFormCheckUser}
                        onCheck={context.setFormErrorCheckUser}
                        model={modelCheckUser}
                    >
                        <Field classNameGroup='mb-10' classNameLabel='font-weight-bold' name="document" label="DNI" />
                        {
                            !ENABLE.enableGetPersonBank &&
                            <Field classNameGroup='mb-3' classNameLabel='font-weight-bold' name="gender" label="Género" accepter={RadioGroup} inline>
                                <Radio value="m">Masculino</Radio>
                                <Radio value="f">Femenino</Radio>
                            </Field>
                        }
                    </Form>
                </div>
            </Modal.Body>
            <Modal.Footer className='mt-4'>
                <div>
                    <Button appearance='subtle' id='cancel_btn' disabled={context.isLoading} onClick={context.onHide} >Cancelar</Button>
                    <Button appearance='primary' id='first_forward' disabled={context.isLoading} onClick={submit} >Siguiente</Button>
                </div>
            </Modal.Footer>
        </>
    );
};
